import { Common } from 'ws-scripts/modules/common';

import React from 'react';
import HoursListItem from './HoursListItem';
import propDefs from '../proptypes';

class HoursList extends React.Component {
	constructor(props) {
		super(props);
		this.renderDelegate = this.renderDelegate.bind(this);
	}

	renderDelegate({ prefs, labels }) {
		const { hours, heading } = this.props;

		if (!hours || hours.length < 1) {
			return null;
		}

		const hourItems = hours.map(h => {
			return <HoursListItem key={h.day} hours={h} prefs={prefs} />;
		});

		const listHeading = heading ? <h3>{labels.get(heading)}</h3> : null;
		const listClasses = `list-unstyled line-height-${prefs.hoursListLineHeight}`;

		return (
			<div>
				{listHeading}
				<ul className={listClasses}>{hourItems}</ul>
			</div>
		);
	}

	render() {
		return <Common render={this.renderDelegate} />;
	}
}

HoursList.defaultProps = {
	hours: propDefs.defaults.hours,
	heading: propDefs.defaults.heading
};

HoursList.propTypes = {
	hours: propDefs.settings.hoursArray,
	heading: propDefs.settings.heading
};

export default HoursList;



// WEBPACK FOOTER //
// ./src/components/HoursList.jsx